import DecimalAmount from "../../../../support/DecimalAmount";

class AbstractDecimalAmount {
  decimales = 2;

  constructor(number, decimales) {
    this.number = number
    this.decimales = decimales
  }

  toFixed() {
    return DecimalAmount.make(this.number).toFixed(this.decimales)
  }

  toString() {
    return DecimalAmount.make(this.number).toString(this.decimales)
  }
}

export default AbstractDecimalAmount;